<template>
  <div class="photography-external-content" id="identidade-visual-fotografia-externa" data-search-anchor>
    <div class="title-photography-external-wrapper">
      <h1 class="photography-external-title-span">{{ photographyExternalTitleSpan }}</h1>
      <h1 class="photography-external-title">{{ photographyExternalTitle }}</h1>
    </div>
    <div class="description-photography-external-wrapper">
      <div>
        <div class="icon-wrapper">
          <IconCheck />
          <p class="photography-external-description">{{ photographyExternalDescription1 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="photography-external-description">{{ photographyExternalDescription2 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="photography-external-description">{{ photographyExternalDescription3 }}</p>
        </div>
      </div>

      <div>
        <div class="icon-wrapper">
          <IconCheck />
          <p class="photography-external-description">{{ photographyExternalDescription4 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="photography-external-description">{{ photographyExternalDescription5 }}</p>
        </div>
        <div class="photography-external-description-wrapper">
        <p class="fica-a-dica">{{ photographyExternalDescription6 }}</p>
         <p class="photography-external-description" style="width: 430px; padding-left: 0;">{{ photographyExternalDescription7 }}</p>
      </div>
        
      </div>
      
    </div>

    <div class="expandable-image-external">
      <PhotographyExpandableImage :src="photographyExternalImageSrc1" alt="" />
      <PhotographyExpandableImage :src="photographyExternalImageSrc2" alt="" />
      <PhotographyExpandableImage :src="photographyExternalImageSrc3" alt="" />
      <PhotographyExpandableImage :src="photographyExternalImageSrc4" alt="" />
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PhotographyPageMixin from '@/mixins/photography-page-mixin'
import { PhotographyPageStore } from '@/store/visual-identity-page/photography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PhotographyExpandableImage from './PhotographyExpandableImage.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: { IconCheck, PhotographyExpandableImage }
})
export default class PhotographyExternalSection extends Mixins(PhotographyPageMixin) {
  photographyPageStore: PageStoreContract = getModule(PhotographyPageStore, this.$store)

  get photographyExternalTitleSpan(): string {
    return this.getElementTitle(4, 0)
  }

  get photographyExternalTitle(): string {
    return this.getElementText(4, 0)
  }

  get photographyExternalDescription1(): string {
    return this.getElementText(4, 1)
  }

  get photographyExternalDescription2(): string {
    return this.getElementText(4, 2)
  }

  get photographyExternalDescription3(): string {
    return this.getElementText(4, 3)
  }

  get photographyExternalDescription4(): string {
    return this.getElementText(4, 4)
  }

  get photographyExternalDescription5(): string {
    return this.getElementText(4, 5)
  }

  get photographyExternalDescription6(): string {
    return this.getElementText(4, 6)
  }

  get photographyExternalDescription7(): string {
    return this.getElementText(4, 7)
  }

  get photographyExternalImageSrc1(): string {
    return this.getElementMedia(4, 8)
  }

  get photographyExternalImageSrc2(): string {
    return this.getElementMedia(4, 9)
  }

  get photographyExternalImageSrc3(): string {
    return this.getElementMedia(4, 10)
  }

  get photographyExternalImageSrc4(): string {
    return this.getElementMedia(4, 11)
  }

  async getPhotographyPage(): Promise<void> {
    await this.photographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.photographyPageStore.isLoading) {
      await this.getPhotographyPage()
    }
  }
}
</script>

<style lang="scss">
.photography-external-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-photography-external-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.photography-external-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.photography-external-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-photography-external-wrapper {
  position: relative;
  
  display: grid;
  grid-template-columns: 1fr 1fr;  
  column-gap: 1rem;
}

.photography-external-description,
.fica-a-dica {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px; 
}

.expandable-image-external {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;  
}
.photography-external-description-wrapper{
  margin-top: 1rem;
}
</style>
